"use strict";
// Structural mirror of the theme contract in @dunea/plugin-sdk (manifest.ts:
// themeTokensSchema / themeManifestSchema). @dunea/shared can't depend on the
// SDK (it's the leaf package everyone imports), so the shapes are restated
// here and the AI tool's spec asserts every first-party theme passes the real
// zod schema and that THEME_FONT_FAMILIES equals the SDK's THEME_FONTS.
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME_CSS_PATH = exports.THEME_PALETTE_KEYS = exports.THEME_BLOCKS_DIR = exports.THEME_FONT_FAMILIES = void 0;
/** Google Fonts families themes may use. Must equal THEME_FONTS in @dunea/plugin-sdk. */
exports.THEME_FONT_FAMILIES = [
    'Inter',
    'Geist',
    'DM Sans',
    'Manrope',
    'Plus Jakarta Sans',
    'Space Grotesk',
    'Outfit',
    'Sora',
    'Work Sans',
    'Poppins',
    'Montserrat',
    'Raleway',
    'Nunito',
    'Lato',
    'Source Sans 3',
    'IBM Plex Sans',
    'Instrument Serif',
    'Playfair Display',
    'Cormorant Garamond',
    'Fraunces',
    'DM Serif Display',
    'Libre Baskerville',
    'Lora',
    'Merriweather',
    'EB Garamond',
    'Syne',
    'Bricolage Grotesque',
    'JetBrains Mono',
    'Space Mono',
    'Geist Mono',
];
/** Where apply_theme writes a theme's blocks. */
exports.THEME_BLOCKS_DIR = 'frontend/src/blocks/theme';
exports.THEME_PALETTE_KEYS = [
    'background',
    'surface',
    'text',
    'muted',
    'primary',
    'primaryText',
    'accent',
    'border',
];
/** The platform file apply_theme writes; its first line identifies the theme. */
exports.THEME_CSS_PATH = 'frontend/src/dunea/theme.css';
